import BaseContainer from "@base/container/BaseContainer";
import StarsContainer from "./StarsContainer";
import AnimatedBackgroundContainer from "./AnimatedBackgroundContainer";
import gsap from "gsap";
import Utils from "@base/utils/Utils";
import {Signals} from "@/Imports";
import Facade from "@/Facade";

export default class GameBackgroundContainer extends BaseContainer {

  constructor(data = null) {
    super(data)
    this.init()
  }

  init(data) {
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.multiplier.add(this.updateMultiplier, this)

    this.isEarthStarted = false

    this.starsContainer = new StarsContainer()
    this.addChild(this.starsContainer)
    this.starsContainer.x += 230
    this.starsContainer.y -= 200

    this.container = new PIXI.Container()
    this.addChild(this.container)


    const planets1 = new AnimatedBackgroundContainer(['bigPlanet', 'brownPlanet', 'ringPlanet', 'redPlanet'], {minDelay: 1000, maxDelay: 15000, speed: 0.9, sc: 0.4, startX: 0, startY: -300, endY: 700, width: 200})
    planets1.position.set(200, 0)
    this.container.addChild(planets1)

    const station = new AnimatedBackgroundContainer(['spaceStation'], {minDelay: 1000, maxDelay: 15000, speed: 1.2, sc: 0.4, startX: 0, startY: -300, endY: 700, width: 200})
    station.position.set(300, 0)
    this.container.addChild(station)
    const redStonePlanet = new AnimatedBackgroundContainer(['redStonePlanet'], {minDelay: 5000, maxDelay: 25000, speed: 0.6, sc: 0.5, startX: 540, startY: -150, endY: 700, width: 400, isSpine: true, spineAnimationName: 'redStonePlanetAnim'})
    redStonePlanet.position.set(200, 0)
    this.container.addChild(redStonePlanet)

    /*const greenStonePlanet = new AnimatedBackgroundContainer(['greenStonePlanet'], {minDelay: 15000, maxDelay: 25000, speed: 0.8, sc: 0.5, startX: 640, startY: -150, endY: 700, width: 200, isSpine: true, spineAnimationName: 'greenPlanetAnim'})
    greenStonePlanet.position.set(200, 0)
    this.container.addChild(greenStonePlanet)*/

    this.tesla = new PIXI.Sprite(PIXI.Texture.from('tesla'))
    this.tesla.scale.set(0.6)
    this.addChild(this.tesla)
    this.tesla.visible = false

    this.startTesla()

    /*const frame = new PIXI.Graphics()
    frame.lineStyle(1, 0x3e3f63)
    frame.drawRoundedRect(1, 1, Config.currentPattern.mainMask.width - 2, Config.currentPattern.mainMask.height - 2, 15)
    this.addChild(frame)*/

  }

  onMakeBets() {
    this.container.removeChild(this.earth)
    this.earth = null
  }

  onRoundEnd() {
    this.isEarthStarted = false
  }

  updateMultiplier(multiplier) {
    if(multiplier > 1.5 && multiplier < 4 && !this.isEarthStarted) {
      this.isEarthStarted = true
      const chance = Math.random()
      console.log('Chance to see earth is ', chance)
      if(chance > 0.4) {
        this.isEarthStarted = true
        this.earth = new AnimatedBackgroundContainer(['bluePlanet'], {speed: 1, sc: 0.7, startX: 200, startY: 150, endY: 700, width: 200, repeat: 1, immediately: true})
        this.container.addChild(this.earth)
      }
    }
  }

  startTesla() {
    this.tesla.visible = false
    const time = Utils.getRandomInt(5, 10) * 60000
    this.teslaTimer = setTimeout(() => {
      this.goTesla()
    }, time)
  }

  goTesla() {
    this.tesla.position.set(1000, -300)
    this.tesla.visible = true

    Facade.soundManager.play('space_tesla', 0.2, false, 'default')

    gsap.to(this.tesla, 11, {x: -100, y: 700, angle: '-=80' ,onComplete: () => {
        this.startTesla()
      }})
  }


}
